// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base container styles */
.twap-container {
    background: var(--card-background-color);
    border-radius: var(--home-border-radius);
    box-shadow: var(--home-shadow);
    padding: 20px;
    margin: 20px 0;
}

/* Header styles */
.twap-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.twap-title {
    color: black;
    font-size: 24px;
    font-weight: 500;
}

.twap-filter-info {
    color: var(--text-color);
    font-size: 14px;
    opacity: 0.8;
}

/* Table container and base styles */
.twap-table-container {
    overflow-x: auto;
    border: 1px solid black;
    border-bottom: none;
    padding: 1rem 1rem 1rem 1rem;
}

.twap-table {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--app-font-family);
    
}

.twap-table th,
.twap-table td {
    padding: 12px 15px;
    text-align: left;
    font-size: 14px;
    border-bottom: 1px solid #ddd;
}

.twap-table th {
    font-weight: 500;
    /* color: var(--primary-color); */
    white-space: nowrap;
    padding: 12px;
}

/* Header content and sort button styles */
.th-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    white-space: nowrap;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
}

.th-content:hover {
    background: rgb(241, 241, 241);
}

.th-content.active {
    background: rgba(0, 36, 117, 0.15);
}

.sort-button {
    background: none;
    border: none;
    display: inline-flex;
    align-items: center;
    opacity: 0.6;
    transition: all 0.2s ease;
}

.sort-button.active {
    opacity: 1;
}

.sort-button svg {
    width: 16px;
    height: 16px;
    color: var(--primary-color);
    transition: transform 0.2s ease;
}

.sort-direction-indicator {
    font-size: 12px;
    margin-left: 4px;
    opacity: 0.7;
}

/* Row styles */
.twap-table tbody tr:hover {
    background: rgba(0, 0, 0, 0.02);
}

.side {
    font-weight: 500;
    white-space: nowrap;
}

.side.buy {
    color: #00b894;
}

.side.sell {
    color: #ff7675;
}

/* Address link styles */
.address-link {
    color: var(--primary-color);
    text-decoration: none;
    font-family: var(--app-font-family);
    position: relative;
    z-index: 1;
}

.address-link:hover {
    text-decoration: underline;
}

/* Progress bar styles */
.progress-container {
    width: 100%;
    min-width: 150px;
}

.progress-bar-container {
    width: 100%;
    height: 8px;
    background: rgba(0, 36, 117, 0.1);
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 4px;
}

.progress-bar_twap {
    height: 100%;
    background: var(--primary-color);
    border-radius: 4px;
    transition: width 0.3s ease;
}

.progress-info {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: var(--text-color);
}

.progress-percentage {
    font-weight: 500;
}

.progress-time {
    opacity: 0.7;
}

/* Empty state styles */
.no-data {
    text-align: center;
    color: var(--text-color);
    opacity: 0.7;
    padding: 30px !important;
}

/* Flag styles */
.flag {
    display: inline-block;
    margin-left: 4px;
    padding: 1px 4px;
    border-radius: 3px;
    font-size: 10px;
    font-weight: bold;
    opacity: 0.8;
}

.reduce-only {
    background: #ff7675;
    color: white;
}

.post-only {
    background: #0984e3;
    color: white;
}

/* Row selection styles */
.twap-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.twap-row:hover {
    background: rgba(0, 36, 117, 0.05);
}

.twap-row.selected {
    background: rgba(0, 36, 117, 0.08);
}

/* Chart styles */
.twap-chart-wrapper {
    margin-top: 20px;
    padding: 20px;
    background: var(--card-background-color);
    border-radius: var(--home-border-radius);
    box-shadow: var(--home-shadow);
}

.chart-title {
    text-align: center;
    margin-bottom: 20px;
}

.chart-row {
    background-color: transparent;
}

.chart-cell {
    padding: 0 !important;
    background-color: transparent;
}

.chart-cell>div {
    margin: 0;
    border-radius: 0;
    box-shadow: none;
}

/* New Pagination Styles */
.pagination-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1rem;
    border: 1px solid black;
    border-top: none;
}

.pagination-info {
    color: var(--text-color);
    font-size: 14px;
}

.pagination-ellipsis {
    padding: 8px;
    color: var(--text-color);
    opacity: 0.6;
}



.page-number-input {
    width: 60px;
    padding: 6px 8px;
    border: 1px solid rgba(0, 36, 117, 0.2);
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    color: var(--text-color);
}

.page-number-input:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(0, 36, 117, 0.1);
}

.pagination-input {
    margin-left: 8px;
}

.pagination-buttons {
    display: flex;
    gap: 4px;
    align-items: center;
}

.pagination-button {
    padding: 8px 12px;
    border: 1px solid black;
    background: var(--card-background-color);
    color: var(--text-color);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.pagination-button:hover:not(:disabled) {
    background: rgba(0, 36, 117, 0.05);
}

.pagination-button.active {
    background: var(--primary-color);
    color: white;
    border-color: var(--primary-color);
}

.pagination-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.rows-per-page-select {
    padding: 6px 12px;
    border: 1px solid rgba(0, 36, 117, 0.2);
    border-radius: 4px;
    background: var(--card-background-color);
    color: var(--text-color);
    cursor: pointer;
}

.pagination-controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* Responsive styles */
@media (max-width: 768px) {
    .twap-container {
        padding: 15px;
        margin: 15px 0;
    }

    .twap-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .twap-title {
        font-size: 20px;
    }

    .twap-table th,
    .twap-table td {
        padding: 8px;
        font-size: 14px;
    }

    .progress-container {
        min-width: 120px;
    }

    .progress-bar-container {
        height: 6px;
    }

    .progress-info {
        font-size: 11px;
    }

    .pagination-footer {
        flex-direction: column;
        gap: 12px;
        align-items: center;
    }

    .pagination-controls {
        flex-wrap: wrap;
        justify-content: center;
    }

    .pagination-buttons {
        order: 2;
        margin-top: 8px;
    }

    .pagination-input {
        order: 1;
        margin-left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/twap_data.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,wCAAwC;IACxC,wCAAwC;IACxC,8BAA8B;IAC9B,aAAa;IACb,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,YAAY;AAChB;;AAEA,oCAAoC;AACpC;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mCAAmC;;AAEvC;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB,aAAa;AACjB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA,eAAe;AACf;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,mCAAmC;IACnC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA,gBAAgB;AAChB;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,aAAa;IACb,wCAAwC;IACxC,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,YAAY;AAChB;;;;AAIA;IACI,WAAW;IACX,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,wCAAwC;IACxC,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,uCAAuC;IACvC,kBAAkB;IAClB,wCAAwC;IACxC,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,cAAc;IAClB;AACJ","sourcesContent":["/* Base container styles */\n.twap-container {\n    background: var(--card-background-color);\n    border-radius: var(--home-border-radius);\n    box-shadow: var(--home-shadow);\n    padding: 20px;\n    margin: 20px 0;\n}\n\n/* Header styles */\n.twap-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.twap-title {\n    color: black;\n    font-size: 24px;\n    font-weight: 500;\n}\n\n.twap-filter-info {\n    color: var(--text-color);\n    font-size: 14px;\n    opacity: 0.8;\n}\n\n/* Table container and base styles */\n.twap-table-container {\n    overflow-x: auto;\n    border: 1px solid black;\n    border-bottom: none;\n    padding: 1rem 1rem 1rem 1rem;\n}\n\n.twap-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: var(--app-font-family);\n    \n}\n\n.twap-table th,\n.twap-table td {\n    padding: 12px 15px;\n    text-align: left;\n    font-size: 14px;\n    border-bottom: 1px solid #ddd;\n}\n\n.twap-table th {\n    font-weight: 500;\n    /* color: var(--primary-color); */\n    white-space: nowrap;\n    padding: 12px;\n}\n\n/* Header content and sort button styles */\n.th-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    white-space: nowrap;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 4px;\n    transition: background-color 0.2s ease;\n}\n\n.th-content:hover {\n    background: rgb(241, 241, 241);\n}\n\n.th-content.active {\n    background: rgba(0, 36, 117, 0.15);\n}\n\n.sort-button {\n    background: none;\n    border: none;\n    display: inline-flex;\n    align-items: center;\n    opacity: 0.6;\n    transition: all 0.2s ease;\n}\n\n.sort-button.active {\n    opacity: 1;\n}\n\n.sort-button svg {\n    width: 16px;\n    height: 16px;\n    color: var(--primary-color);\n    transition: transform 0.2s ease;\n}\n\n.sort-direction-indicator {\n    font-size: 12px;\n    margin-left: 4px;\n    opacity: 0.7;\n}\n\n/* Row styles */\n.twap-table tbody tr:hover {\n    background: rgba(0, 0, 0, 0.02);\n}\n\n.side {\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.side.buy {\n    color: #00b894;\n}\n\n.side.sell {\n    color: #ff7675;\n}\n\n/* Address link styles */\n.address-link {\n    color: var(--primary-color);\n    text-decoration: none;\n    font-family: var(--app-font-family);\n    position: relative;\n    z-index: 1;\n}\n\n.address-link:hover {\n    text-decoration: underline;\n}\n\n/* Progress bar styles */\n.progress-container {\n    width: 100%;\n    min-width: 150px;\n}\n\n.progress-bar-container {\n    width: 100%;\n    height: 8px;\n    background: rgba(0, 36, 117, 0.1);\n    border-radius: 4px;\n    overflow: hidden;\n    margin-bottom: 4px;\n}\n\n.progress-bar_twap {\n    height: 100%;\n    background: var(--primary-color);\n    border-radius: 4px;\n    transition: width 0.3s ease;\n}\n\n.progress-info {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    color: var(--text-color);\n}\n\n.progress-percentage {\n    font-weight: 500;\n}\n\n.progress-time {\n    opacity: 0.7;\n}\n\n/* Empty state styles */\n.no-data {\n    text-align: center;\n    color: var(--text-color);\n    opacity: 0.7;\n    padding: 30px !important;\n}\n\n/* Flag styles */\n.flag {\n    display: inline-block;\n    margin-left: 4px;\n    padding: 1px 4px;\n    border-radius: 3px;\n    font-size: 10px;\n    font-weight: bold;\n    opacity: 0.8;\n}\n\n.reduce-only {\n    background: #ff7675;\n    color: white;\n}\n\n.post-only {\n    background: #0984e3;\n    color: white;\n}\n\n/* Row selection styles */\n.twap-row {\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.twap-row:hover {\n    background: rgba(0, 36, 117, 0.05);\n}\n\n.twap-row.selected {\n    background: rgba(0, 36, 117, 0.08);\n}\n\n/* Chart styles */\n.twap-chart-wrapper {\n    margin-top: 20px;\n    padding: 20px;\n    background: var(--card-background-color);\n    border-radius: var(--home-border-radius);\n    box-shadow: var(--home-shadow);\n}\n\n.chart-title {\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.chart-row {\n    background-color: transparent;\n}\n\n.chart-cell {\n    padding: 0 !important;\n    background-color: transparent;\n}\n\n.chart-cell>div {\n    margin: 0;\n    border-radius: 0;\n    box-shadow: none;\n}\n\n/* New Pagination Styles */\n.pagination-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 1rem;\n    border: 1px solid black;\n    border-top: none;\n}\n\n.pagination-info {\n    color: var(--text-color);\n    font-size: 14px;\n}\n\n.pagination-ellipsis {\n    padding: 8px;\n    color: var(--text-color);\n    opacity: 0.6;\n}\n\n\n\n.page-number-input {\n    width: 60px;\n    padding: 6px 8px;\n    border: 1px solid rgba(0, 36, 117, 0.2);\n    border-radius: 4px;\n    text-align: center;\n    font-size: 14px;\n    color: var(--text-color);\n}\n\n.page-number-input:focus {\n    outline: none;\n    border-color: var(--primary-color);\n    box-shadow: 0 0 0 2px rgba(0, 36, 117, 0.1);\n}\n\n.pagination-input {\n    margin-left: 8px;\n}\n\n.pagination-buttons {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n}\n\n.pagination-button {\n    padding: 8px 12px;\n    border: 1px solid black;\n    background: var(--card-background-color);\n    color: var(--text-color);\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.pagination-button:hover:not(:disabled) {\n    background: rgba(0, 36, 117, 0.05);\n}\n\n.pagination-button.active {\n    background: var(--primary-color);\n    color: white;\n    border-color: var(--primary-color);\n}\n\n.pagination-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.rows-per-page-select {\n    padding: 6px 12px;\n    border: 1px solid rgba(0, 36, 117, 0.2);\n    border-radius: 4px;\n    background: var(--card-background-color);\n    color: var(--text-color);\n    cursor: pointer;\n}\n\n.pagination-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n    .twap-container {\n        padding: 15px;\n        margin: 15px 0;\n    }\n\n    .twap-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .twap-title {\n        font-size: 20px;\n    }\n\n    .twap-table th,\n    .twap-table td {\n        padding: 8px;\n        font-size: 14px;\n    }\n\n    .progress-container {\n        min-width: 120px;\n    }\n\n    .progress-bar-container {\n        height: 6px;\n    }\n\n    .progress-info {\n        font-size: 11px;\n    }\n\n    .pagination-footer {\n        flex-direction: column;\n        gap: 12px;\n        align-items: center;\n    }\n\n    .pagination-controls {\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n\n    .pagination-buttons {\n        order: 2;\n        margin-top: 8px;\n    }\n\n    .pagination-input {\n        order: 1;\n        margin-left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
